module.exports = __webpack_public_path__ + "img/ic-sad.edfa6c1a.png";